import axios from "axios";

export const state = {
    diseases: [],
};

export const getters = {
    diseases: state => state.diseases,
};

export const mutations = {
    setDiseases(state, newValue) {
        state.diseases = newValue
    },
};

export const actions = {
    fetchDiseases({ commit }) {
        axios.get('/diseases').then(res => {
            commit('setDiseases', res.data.diseases);
        })
    },
};